export const GET_COUNTRY_STATE_WATCHER = 'GET_COUNTRY_STATE_WATCHER';
export const GET_COUNTRY_STATE_SUCCESS = 'GET_COUNTRY_STATE_SUCCESS';
export const GET_COUNTRY_STATE_FAILED = 'GET_COUNTRY_STATE_FAILED';
